export default "__VITE_ASSET__CSAbADwc__"